import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ContentAccessSettingsPublishNotice from 'ui-memberships-settings-lib/components/ContentAccessSettingsPublishNotice';
// @ts-expect-error Untyped module
import { getContentTypeSlug } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import { getUnifiedPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getAbsoluteUrl, getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import useContentCrmObject from 'ContentEditorUI/components/publishing/hooks/useContentCrmObject';
import { getContentModelName, getContentModelPublicAccessRules, getContentModelPublicAccessRulesEnabled } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getContentTypeId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getPortalHasMembershipsAccess } from '../redux/selectors/authSelectors';
import { getContentModelPassword } from '../redux/selectors/pageContentModelSelectors';
import { getPageSettingsFullUrl } from '../redux/selectors/pageSettingsSelectors';
import { getMembershipSsoEnabledForDomain } from '../redux/selectors/membershipsSelectors';
import { CategoryIdToAccessControlContentType, ContentTypes } from 'ui-memberships-settings-lib/constants/ContentTypes';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "PagePublishConfirmModalBody__Bold",
  componentId: "sc-1cflmt7-0"
})(["font-weight:bold;"]);
const PagePublishConfirmModalBody = ({
  isEmailSendingAcknowledgementChecked,
  onEmailSendingAcknowledgementChange,
  onUnregisteredContactsCountFetchSuccess
}) => {
  const {
    contentCrmObjectPublishType,
    contentObjectType
  } = useContentCrmObject();
  const publishType = useSelector(getUnifiedPublishType);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const absoluteUrl = useSelector(getAbsoluteUrl);
  const constructedFullUrl = useSelector(getPageSettingsFullUrl);
  const contentType = useSelector(getContentTypeSlug);
  const name = useSelector(getContentModelName);
  const urlToDisplay = isBlogListingPage ? absoluteUrl : constructedFullUrl;
  const publishKey = contentCrmObjectPublishType === PublishTypes.publish || publishType === PublishTypes.publish ? 'publishWithoutUrl' : 'publish';
  const portalHasMembershipsAccess = useSelector(getPortalHasMembershipsAccess);
  const contentTypeId = useSelector(getContentTypeId);
  const membershipsContentType = CategoryIdToAccessControlContentType[contentTypeId] || ContentTypes.CONTENT;
  const pagePassword = useSelector(getContentModelPassword);
  const pagePublicAccessRules = useSelector(getContentModelPublicAccessRules);
  const pagePublicAccessRulesEnabled = useSelector(getContentModelPublicAccessRulesEnabled);
  const ssoEnabledForPageDomain = useSelector(getMembershipSsoEnabledForDomain);
  const contentAccessProperties = useMemo(() => [{
    password: pagePassword,
    publicAccessRules: pagePublicAccessRules,
    publicAccessRulesEnabled: pagePublicAccessRulesEnabled,
    isSSOEnabled: ssoEnabledForPageDomain
  }], [pagePassword, pagePublicAccessRules, pagePublicAccessRulesEnabled, ssoEnabledForPageDomain]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.contentInfo.name",
        options: {
          name
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "publishConfirmModal.contentInfo.url_jsx",
        options: {
          url: urlToDisplay
        },
        elements: {
          UILink: Link,
          Bold
        }
      })]
    }), contentCrmObjectPublishType !== PublishTypes.update || publishType !== PublishTypes.update ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `publishConfirmModal.body.${contentObjectType || contentType}.${publishKey}`,
      options: {
        contentUrl: urlToDisplay
      }
    }) : null, portalHasMembershipsAccess && /*#__PURE__*/_jsx(ContentAccessSettingsPublishNotice, {
      contentType: membershipsContentType,
      contentAccessProperties: contentAccessProperties,
      isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
      onEmailSendingAcknowledgementChange: onEmailSendingAcknowledgementChange,
      onUnregisteredContactsCountFetchSuccess: onUnregisteredContactsCountFetchSuccess
    })]
  });
};
export default PagePublishConfirmModalBody;